/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M7 3V10M7 22L3 18M7 22L11 18M7 22V14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16 2H21L16 10H21M16 22V19M16 19V16.5C16 15.1193 17.1193 14 18.5 14C19.8807 14 21 15.1193 21 16.5V19M16 19H21M21 19V22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<g opacity="0.12">
				<path d="M21 2H16V10H21V2Z" fill="currentColor" />
				<path
					d="M16 19V22H21V19V16.5C21 15.1193 19.8807 14 18.5 14C17.1193 14 16 15.1193 16 16.5V19Z"
					fill="currentColor"
				/>
			</g>
			<path
				d="M7 22L3 18M7 22L11 18M7 22V14M7 3V10M16 2H21L16 10H21M16 22V19M16 19V16.5C16 15.1193 17.1193 14 18.5 14C19.8807 14 21 15.1193 21 16.5V19M16 19H21M21 19V22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M7 22L3 18M7 22L11 18M7 22V14M7 3V10M16 2H21L16 10H21M16 22V19M16 19V16.5C16 15.1193 17.1193 14 18.5 14C19.8807 14 21 15.1193 21 16.5V19M16 19H21M21 19V22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M11 18L7 22V14M7 3V10M4.5 19.5L3 18M16 2H21L16 10H21M16 22V19M16 19V16.5C16 15.1193 17.1193 14 18.5 14C19.8807 14 21 15.1193 21 16.5V19M16 19H21M21 19V22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M7 22L3 18M7 22L11 18M7 22V14M7 3V10M16 2H21L16 10H21M16 22V19M16 19V16.5C16 15.1193 17.1193 14 18.5 14C19.8807 14 21 15.1193 21 16.5V19M16 19H21M21 19V22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M7 22L3 18M7 22L11 18M7 22V14M7 3V10M16 2H21L16 10H21M16 22V19M16 19V16.5C16 15.1193 17.1193 14 18.5 14C19.8807 14 21 15.1193 21 16.5V19M16 19H21M21 19V22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
